var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavTrain = function SvgNavTrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.75,
    d: "M17.5 17.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "m19.6 25-2.1-2.5M7 20.5c-1.1 0-2-.8-2.1-1.9L4.5 14V4.5C4.5 2.6 6.1 1 8 1h10c1.9 0 3.5 1.6 3.5 3.5V14l-.4 4.7c-.1 1-1 1.8-2.1 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.75,
    d: "M8.5 17.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6 6.5h16.9M5 11.5l8 .5 8-.5"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.5 25 2.1-2.5M7.8 23.5h10.6"
  })))));
};
export default SvgNavTrain;